<div
  class="gift-banner"
  [ngClass]="{ 'gift-banner__mBottom': bottomSpacing, 'gift-banner__mTop': topSpacing }">
  <img
    alt="gift"
    src="https://media.sharry.land/app/images/gift-card/gift-card-banner-2.webp" />
  <p [innerHTML]="'sharry.gift-banner.text' | i18next"></p>
  <a
    class="rounded small"
    color="secondary"
    mat-stroked-button
    [routerLink]="'gift-card' | routeTranslate">
    {{ 'sharry.gift-banner.btn' | i18next }}
  </a>
</div>
